<template>
  <div class="top">
    <Loading v-show="loading"></Loading>
    <div class="header-contents">
      <img src="../assets/header-image.jpg" id="header-image" width="100%" alt="">
      <img src="../assets/sp-header-image.jpg" id="sp-header-image" width="100%" alt="">
      <div class="left-content">
        <div style="text-align:center;">
          <h1>7200Kcal</h1>
          <a href="/plan">有料会員登録¥ 180/月</a>
        </div>
      </div>
      <div class="right-content">
        <p>ダイエットや減量をする人のための献立表<br>栄養士が監修する<br>１日の摂取カロリーを考えた<br>健康献立３食分を<br>毎日ご提案します。</p>
      </div>
    </div>
    <div class="main-contents">
      <div class="first-contents">
        <p class="main-title">ダイエット・減量期間中の食事<br>もう考える必要はありません。</p>
        <div class="wp-flexbox">
          <div class="flexbox">
            <div class="item">
              <img src="../assets/menu.png" alt="" />
              <p class="title">毎日の健康的な食事を提案<br><br><br><span class="description">栄養士が栄養素を重視して考案した献立を、<br>毎日３食分提案します。<br>日々の食事をプロの提案にお任せ。</span></p>
            </div>
            <div class="item">
              <img src="../assets/mail.png" alt="" />
              <p class="title">3日ごとに献立と<br>買い物リストをお知らせ<br><br><span class="description">3日分のお買い物リストがあることで、<br>買う物に迷うことがなく買い出しができます。<br>Instagram又はMailにて受取可能</span></p>
            </div>
            <div class="item">
              <img src="../assets/advice.png" alt="" />
              <p class="title">レシピごとに栄養を考えた<br>ワンポイントアドバイス付き<br><br><span class="description">献立ごとにカロリーの調整ができるよう、<br>管理栄養士から献立アレンジをアドバイス。<br>軽いダイエットや高度な減量などにも柔軟に対応。</span></p>
            </div>
          </div>
        </div>
        <div class="sp-flexbox">
          <div class="row">
            <table>
              <tbody>
                <tr>
                  <td class="k-tr"><img src="../assets/menu.png" alt="" /></td>
                  <td class="v-tr"> <p class="title">毎日の健康的な食事を提案<br><span class="description">栄養士が栄養素を重視して考案した献立を、毎日３食分提案します。日々の食事をプロの提案にお任せ。</span></p></td>
                </tr>
                <tr>
                  <td class="k-tr"><img src="../assets/mail.png" alt="" /></td>
                  <td class="v-tr"> <p class="title">3日ごとに献立と<br>買い物リストをお知らせ<br><span class="description">3日分のお買い物リストがあることで、買う物に迷うことがなく買い出しができます。Instagram又はMailにて受取可能</span></p></td>
                </tr>
                <tr>
                  <td class="k-tr"><img src="../assets/advice.png" alt="" /></td>
                  <td class="v-tr"> <p class="title">レシピごとに栄養を考えた<br>ワンポイントアドバイス付き<br><span class="description">献立ごとにカロリーの調整ができるよう、管理栄養士から献立アレンジをアドバイス。軽いダイエットや高度な減量などにも柔軟に対応。</span></p></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="text-align:center;">
          <a href="/plan">有料会員登録¥ 180/月</a>
        </div>
      </div>
      <div class="second-contents">
        <img src="../assets/second-top-bg.jpg" alt="">
        <div class="right-content">
          <h2>脂肪１kg=7200Kcal</h2>
          <p>体重を１kg減らすには、７２００Kcalの消費が必要です。<br>１ヶ月で１Kg落とすには、<br>１日２４０Kcalを消費しなければなりません。</p><br>
          <p>つまり、１日に消費するカロリーより<br>２４０Kcal少ない食事を摂取することが必要です。<br>(<span style="color:green;">１日の目標摂取カロリー</span>)＝(１日の消費カロリー)-(２４０Kcal)</p>
          <a href="/plan">有料会員登録¥ 180/月</a>
        </div>
      </div>
      <div class="third-contents">
        <div class="flexbox">
          <section class="main">
            <img src="../assets/third-content-1.jpg" alt="" />
          </section>
          <section class="side">
            <h6>身体が喜ぶ食事を提案</h6>
            <p>ただ痩せるだけの食事になっていませんか？</p>
            <p>カロリーを気にした食事により栄養に偏りが出てしまっては、かえって不健康です。7200Kcalで食事を管理して、健康的に体の管理をしませんか？</p>
          </section>
        </div>
        <div class="flexbox">
          <section class="main">
            <h6>提案型だから続けられる</h6>
            <p>ダイエット何回挫折してますか？</p>
            <p>自己流のやり方ではほとんどの方が「辛い....」というような状態に陥り、折角始めたダイエットもすぐに挫折してしまいます。</p>
          </section>
          <section class="side">
            <img src="../assets/third-content-2.jpg" alt="" />
          </section>
        </div>
        <div class="flexbox">
          <section class="main">
            <img src="../assets/third-content-3.jpg" alt="" />
          </section>
          <section class="side">
            <h6>始めと終わりのタイミングはあなた次第</h6>
            <p>いつでも登録・解約ができる</p>
            <p>本サービスはいつでも登録・解約が可能です。ご自身で7200Kcal流のダイエットを実行s切るタイミングで止めることも簡単にできます。</p>
          </section>
        </div>
        <div class="sp-flexbox">
          <section class="main">
            <img src="../assets/third-content-1.jpg" alt="" />
          </section>
          <section class="side">
            <h6>身体が喜ぶ食事を提案</h6>
            <p>ただ痩せるだけの食事になっていませんか？</p>
            <p>カロリーを気にした食事により栄養に偏りが出てしまっては、かえって不健康です。7200Kcalで食事を管理して、健康的に体の管理をしませんか？</p>
          </section>
        </div>
        <div class="sp-flexbox">
          <section class="main">
            <img src="../assets/third-content-2.jpg" alt="" />
          </section>
          <section class="side">
            <h6>提案型だから続けられる</h6>
            <p>ダイエット何回挫折してますか？</p>
            <p>自己流のやり方ではほとんどの方が「辛い....」というような状態に陥り、折角始めたダイエットもすぐに挫折してしまいます。</p>
          </section>
        </div>
        <div class="sp-flexbox">
          <section class="main">
            <img src="../assets/third-content-3.jpg" alt="" />
          </section>
          <section class="side">
            <h6>始めと終わりのタイミングはあなた次第</h6>
            <p>いつでも登録・解約ができる</p>
            <p>本サービスはいつでも登録・解約が可能です。ご自身で7200Kcal流のダイエットを実行s切るタイミングで止めることも簡単にできます。</p>
          </section>
        </div>
        <a href="/plan">有料会員登録¥ 180/月</a>
      </div>
      <div class="fourth-contents">
        <p class="title">１日の献立例</p>
        <p class="description">Totalカロリー: 1450Kcal</p>
        <div class="flexbox">
          <div class="item">
            <img src="../assets/yoguruto.jpg" alt="" />
            <p class="morning">Morning</p>
            <p class="menu">ヨーグルトwithフルーツ</p>
            <p class="kcal">350Kcal</p>
          </div>
          <div class="item">
            <img src="../assets/tantanmen.jpg" alt="" />
            <p class="lunch">Lunch</p>
            <p class="menu">青梗菜の坦々麺</p>
            <p class="kcal">700Kcal</p>
          </div>
          <div class="item">
            <img src="../assets/salad.jpg" alt="" />
            <p class="dinner">Dinner</p>
            <p class="menu">5品目のサラダボウル</p>
            <p class="kcal">400Kcal</p>
          </div>
        </div>
        <a href="/plan">有料会員登録¥ 180/月</a>
      </div>
      <div class="five-contents">
        <p class="title">料金プラン</p>
        <div class="price-inner">
          <p class="sub-title">毎日３食分の献立</p>
          <p>〜毎日配信〜</p>
          <p>＋</p>
          <p class="sub-title">買い物リスト</p>
          <p>〜3日毎に配信〜</p>
          <p>＋</p>
          <p class="sub-title">オリジナル外食カロリー表</p>
          <p>〜定期的に更新〜</p>
          <p class="price">¥ 180/月(税抜)</p>
        </div>
        <a href="/plan">有料会員登録¥ 180/月</a>
      </div>
      <div class="six-contents">
        <p class="title">Instagram</p>
        <p class="description">#7200Kcal</p>
        <iframe src="https://snapwidget.com/embed/871076" class="snapwidget-widget" allowtransparency="true" frameborder="0" scrolling="no" style="border:none; overflow:hidden;  width:100%; "></iframe>
        <a href="https://www.instagram.com/7200kcal_recipe/">フォローする</a>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.item {
  padding: 15px;
  margin: 5px;
  text-align: center;
}
img {
  max-width: 100%;
  height: auto;
}
p {
  text-align: left;
}
.header-contents{
  position: relative;
}
.header-contents .left-content{
  width: 50%;
  position: absolute;
  top:25%;
  left: 5%;
}
.header-contents .left-content h1{
  font-size: 72px;
  color: white;
}
.header-contents .left-content a{
  background: black;
  color: white;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  font-size: 24px;
  padding-left: 64px;
  padding-right: 64px;
  padding-bottom :16px;
}
.header-contents .right-content{
  position: absolute;
  width: 40%;
  top:15%;
  right: 5%;
}
.header-contents .right-content p{
  font-size: 22px;
  text-align: center;
  padding:5%;
  background: rgba(255,255,255,0.5);
  line-height: 64px;
  border-radius: 50px 50px 50px 50px;
}
.first-contents .main-title{
  font-size: 22px;
  text-align: center;
  line-height: 48px;
}
.first-contents .item img{
  width: 96px;
}
.first-contents .item .title{
  text-align: center;
}
.first-contents .item .description{
  text-align: left;
  padding-left: 5%;
  padding-right: 5%;
  font-size: 12px;
  font-family: Hiragino Kaku Gothic Pro;
}
.first-contents .item {
  width: 20%;
}
.first-contents a{
  background: black;
  color: white;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  font-size: 24px;
  padding-left: 64px;
  padding-right: 64px;
  padding-bottom :16px;
}
.second-contents {
  width: 100%;
  margin-top: 5%;
}
.second-contents img{
  width: 100%;
}
.second-contents {
  position: relative;
}
.second-contents h2{
  font-size: 36px;
  color: green;
}
.second-contents .right-content{
 position: absolute;
  top:25%;
  width: 40%;
  right: 5%;
}
.second-contents p{
 text-align: center;
 line-height: 48px;
}
.second-contents a{
  background: black;
  color: white;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  font-size: 24px;
  padding-left: 64px;
  padding-right: 64px;
  padding-bottom :16px;
}
.main {
  width: 35%;
}
.side {
  width: 35%;
}
.main,
.side {
  border-radius: 10px
}
.third-contents{
   padding-top: 5%;
  padding-bottom: 5%;
}
.third-contents .main{
  padding:5%;
}
.third-contents .side{
  padding:5%;
}
.third-contents .flexbox p, h6{
  text-align: left;
}
.third-contents a {
  background: black;
  color: white;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  font-size: 24px;
  padding-left: 64px;
  padding-right: 64px;
  padding-bottom :16px;
}
.fourth-contents a{
  background: black;
  color: white;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  font-size: 24px;
  padding-left: 64px;
  padding-right: 64px;
  padding-bottom :16px;
}
.fourth-contents .item {
  border-radius: 10px;
  padding: 15px;
  margin: 5px;
  text-align: center;
}
.fourth-contents img {
  max-width: 100%;
  height: auto;
}
.fourth-contents p {
  text-align: center;
}
.fourth-contents .title{
  text-align: center;
  font-size: 32px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.fourth-contents .description{
  text-align: center;
  font-family: Hiragino Kaku Gothic Pro;
  margin-top: 0px;
  margin-bottom: 0px;
}
.fourth-contents {
  padding-top: 5%;
  padding-bottom: 5%;
  background: #EEEEEE;
}
.five-contents p{
  margin-top: 0px;
}
.third-contents .sp-flexbox{
  display: none;
}
/* Responsive */
@media ( min-width : 600px ){
    .fourth-contents .flexbox {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    }
  .fourth-contents .item {
    width: 25%;
  }
}
@media ( min-width : 600px ){
    .flexbox {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    }
  .item {
    width: 25%;
  }
}
.first-contents .main-title{
  text-align: center;
}
.fourth-contents img{
  width: 200px;
  border-radius: 50px 50px 50px 50px;
}
.five-contents {
  position: relative;
  height: auto;
  padding-top: 5%;
  padding-bottom: 5%;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("../assets/bg-transparent.jpg");
}
.five-contents .title{
  font-size: 32px;
  text-align: center;
}
.five-contents a{
  background: black;
  color: white;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  font-size: 24px;
  padding-left: 64px;
  padding-right: 64px;
  padding-bottom :16px;
}
.five-contents .price-inner{
  padding:5%;
  background:rgba(255,255,255);
  border: 3px inset black;
  width: 20%;
  margin:5% auto;
}
.five-contents .sub-title{
  font-size:24px;
}
.five-contents .price-inner p{
  text-align: center;
}
.five-contents .price{
  color: red;
  font-size:24px;
}
.six-contents{
  padding-top: 5%;
  padding-bottom: 5%;
}
.six-contents .title{
  font-size: 32px;
}
.six-contents .description{
  font-size: 24px;
}
.six-contents p{
  text-align: center;
}
.six-contents a{
  background: black;
  color: white;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  font-size: 24px;
  padding-left: 64px;
  padding-right: 64px;
  padding-bottom :16px;
}
.snapwidget-widget{
  margin-top:5%;
  margin-bottom: 5%;
  height: 400px;
}
#sp-header-image{
  display: none;
}
.sp-flexbox{
  display: none;
}
@media ( max-width : 600px ){
#sp-header-image{
  display: block;
}
#header-image{
  display: none;
}
.header-contents{
  position: relative;
}
.header-contents .right-content {
  position: absolute;
  width: 100%;
  top:0px;
  left: 0px;
}
.header-contents .right-content p{
  font-size: 16px;
  text-align: center;
  padding:5%;
  background: transparent;
  line-height: 24px;
  border-radius: 50px 50px 50px 50px;
}
.header-contents .left-content {
  position: absolute;
  bottom:5%;
  top:initial;
  left: 0px;
  width: 100%;
}
.header-contents .left-content a{
  background: black;
  color: white;
  font-size: 18px;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom :16px;
}
.header-contents .left-content h1{
  display: none;
}
.first-contents .main-title{
  font-size: 18px;
  text-align: center;
  line-height: 24px;
}
.second-contents h2 {
    display: none;
}
.wp-flexbox{
  display: none;
}
.sp-flexbox{
  display: block;
}
.sp-flexbox .row img{
  display: inline-block;
  width: 64px;
}
.sp-flexbox .row p{
  display: inline-block;
  padding-right: 5%;
}
.sp-flexbox .row .title{
  font-size: 10px;
  margin-bottom: 24px;
}
.sp-flexbox .row .description{
  font-size: 8px;
  line-height: 15px;
  font-family: Hiragino Kaku Gothic Pro;
}
.first-contents a{
  background: black;
  color: white;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  font-size: 18px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom :16px;
}
.first-contents{
  padding-top: 5%;
  padding-bottom: 5%;
}
.sp-flexbox .v-tr{
  text-align: left;
}
.sp-flexbox .k-tr{
  width: 40%;
  text-align: center;
}
.second-contents h2{
  font-size: 16px;
  color: green;
}
.second-contents p{
 text-align: center;
 font-size: 8px;
 line-height: 14px;
 display: none;
}
.second-contents a{
  display: none;
}
.third-contents .sp-flexbox{
  display: block;
}
.third-contents{
  padding-top: 5%;
  padding-bottom: 5%;
}
.third-contents .flexbox{
  display:none;
}
.third-contents .main {
    width: 90%;
}
.third-contents .side {
    width: 90%;
}
.third-contents a{
  background: black;
  color: white;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  font-size: 18px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom :16px;
}
.fourth-contents a{
  background: black;
  color: white;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  font-size: 18px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom :16px;
}
.five-contents a{
  background: black;
  color: white;
  border-radius: 50px 50px 50px 50px;
  padding-top :16px;
  font-size: 18px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom :16px;
}
.five-contents .price-inner {
    padding: 5%;
    background: rgba(255,255,255);
    border: 3px inset black;
    width: 80%;
    margin: 5% auto;
}
.snapwidget-widget{
  height: initial;
}
}
</style>

<script>
import Loading from './common/Loading'
import Footer from '../components/common/Footer'

export default {
  name: 'HelloWorld',
  components: {
    Loading, Footer
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      loading: false
    }
  },
  created : function(){
    this.loading = true
  },
  mounted : function(){
    let self = this
    setTimeout(function () {
      self.loading = false
    }, 1000);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Top.vue